import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { MemberRole_Admin_getInstance3iiznt2spfc6m as MemberRole_Admin_getInstance } from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  SubtitleSemantic_getInstance37873sehsd699 as SubtitleSemantic_getInstance,
  bodyBold2czwdzwknab0k as bodyBold,
} from '../../theming/Titles.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Dimensions32ju1l7z4mh as Dimension } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import { AppColors_getInstance3ty7139j9u8g2 as AppColors_getInstance } from '../../theming/AppColors.mjs';
import { colored3y8uibz1hk46 as colored } from '../../theming/colorManagement.mjs';
import { FieldSemantic_getInstance2sngfoinp7a00 as FieldSemantic_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { assertNotBlank3rcqh0n27fq5q as assertNotBlank } from '../../../../../../reactive/com/lightningkite/reactive/lensing/validation/helpers.mjs';
import { TextInput22lgsa81snd26 as TextInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextField.commonHtml.mjs';
import {
  User8yb1tqk4kykg as User,
  Companion_getInstance21u335vgn0mpe as Companion_getInstance,
} from '../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_emailn9rmxjmv5jjf as get_email,
  get_phoneNumberwyjkikct2tk8 as get_phoneNumber,
  get_addressm9hct5lany5j as get_address,
} from '../../../../../../crowpay-shared/com/crowpay/UserFields.mjs';
import { lensPath16mstx1fbm6dz as lensPath } from '../../../../../../lightning-server-kiteui-client/com/lightningkite/serialization/MutableReactive.lens.DataClassPath.mjs';
import {
  assertValidEmail3utsnuo6xdy4w as assertValidEmail,
  assertValidPhoneNumber13ya35cr3f72y as assertValidPhoneNumber,
} from '../../../utils/validation.mjs';
import { PhoneNumberInput1tdzv8kpf7vme as PhoneNumberInput } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/PhoneNumberInput.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { addressForm32k03uh8crpev as addressForm } from '../../components/addressForm.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function UserForm$render$lambda(it) {
  return it.h88_1;
}
function UserForm$render$lambda_0(og, it) {
  return og.v88(VOID, VOID, VOID, VOID, it);
}
function UserForm$render$lambda_1(it) {
  return it.i88_1;
}
function UserForm$render$lambda_2(og, it) {
  return og.v88(VOID, VOID, VOID, VOID, VOID, it);
}
var UserFormClass;
function UserForm() {
  if (UserFormClass === VOID) {
    class $ {
      constructor(user, allowEditingEmail, widthLimit) {
        this.vj0_1 = user;
        this.wj0_1 = allowEditingEmail;
        this.xj0_1 = widthLimit;
        var tmp = this;
        tmp.yj0_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.let' call
          var it = $this$remember.daj(this.vj0_1).k88_1;
          return it == null || it.h8c_1.equals(MemberRole_Admin_getInstance());
        });
      }
      wd6(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.ebb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.gbb(p, view);
        view.zbm(true);
        // Inline function 'com.crowpay.views.theming.subTitle' call
        var content = 'User Information';
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (TextView())(view.pc());
        var tmp0_elvis_lhs_0 = view.ebb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.gbb(p_0, view_0);
        view_0.lba(view_0.qb6_1.abf(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp = view_0.vb5_1;
        var tmp_0;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(content) === 0) {
          tmp_0 = '\xA0';
        } else {
          tmp_0 = content;
        }
        tmp.hbu(tmp_0);
        view.hbb(p_0, view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
        var breakpoint = this.xj0_1;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowCollapsingToColumn())(view.pc(), listOf(new (Dimension())(breakpoint)));
        var tmp0_elvis_lhs_1 = view.ebb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view : tmp0_elvis_lhs_1;
        view.gbb(p_1, view_1);
        var tmp_1 = get_expanding(view_1);
        // Inline function 'com.crowpay.views.components.requiredField' call
        var label = 'First Name';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.ebb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.gbb(p_2, view_2);
        view_2.zbm(true);
        view_2.bb9(get_AppDimensions().pg2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (RowOrCol())(view_2.pc());
        var tmp0_elvis_lhs_3 = view_2.ebb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
        view_2.gbb(p_3, view_3);
        view_3.zbm(false);
        view_3.bb9(get_AppDimensions().rg2_1);
        view_3.lbb(get_centered(view_3), bodyBold(view_3, label));
        view_3.lbb(colored(view_3, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_3, '*'));
        view_2.hbb(p_3, view_3);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_2 = view_2.jbb(FieldSemantic_getInstance());
        var tmp_3 = UserForm$render$lambda;
        var value = assertNotBlank(this.vj0_1.dak(tmp_3, UserForm$render$lambda_0));
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (TextInput())(view_2.pc());
        var tmp0_elvis_lhs_4 = view_2.ebb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
        view_2.gbb(p_4, view_4);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        var value_0 = 'First Name';
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_4.vb5_1.bb4_1.kb7_1.placeholder = value_0;
        view_4.zah(view_4.icn_1, value);
        view_2.hbb(p_4, view_4);
        view_2.lbb(tmp_2, view_4);
        view_1.hbb(p_2, view_2);
        view_1.lbb(tmp_1, view_2);
        var tmp_4 = get_expanding(view_1);
        // Inline function 'com.crowpay.views.components.requiredField' call
        var label_0 = 'Last Name';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (RowOrCol())(view_1.pc());
        var tmp0_elvis_lhs_5 = view_1.ebb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_1 : tmp0_elvis_lhs_5;
        view_1.gbb(p_5, view_5);
        view_5.zbm(true);
        view_5.bb9(get_AppDimensions().pg2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (RowOrCol())(view_5.pc());
        var tmp0_elvis_lhs_6 = view_5.ebb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
        view_5.gbb(p_6, view_6);
        view_6.zbm(false);
        view_6.bb9(get_AppDimensions().rg2_1);
        view_6.lbb(get_centered(view_6), bodyBold(view_6, label_0));
        view_6.lbb(colored(view_6, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_6, '*'));
        view_5.hbb(p_6, view_6);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_5 = view_5.jbb(FieldSemantic_getInstance());
        var tmp_6 = UserForm$render$lambda_1;
        var value_1 = assertNotBlank(this.vj0_1.dak(tmp_6, UserForm$render$lambda_2));
        // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (TextInput())(view_5.pc());
        var tmp0_elvis_lhs_7 = view_5.ebb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view_5 : tmp0_elvis_lhs_7;
        view_5.gbb(p_7, view_7);
        // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
        var value_2 = 'Last Name';
        // Inline function 'com.lightningkite.kiteui.views.placeholder' call
        view_7.vb5_1.bb4_1.kb7_1.placeholder = value_2;
        view_7.zah(view_7.icn_1, value_1);
        view_5.hbb(p_7, view_7);
        view_5.lbb(tmp_5, view_7);
        view_1.hbb(p_5, view_5);
        view_1.lbb(tmp_4, view_5);
        view.hbb(p_1, view_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
        var breakpoint_0 = this.xj0_1;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (RowCollapsingToColumn())(view.pc(), listOf(new (Dimension())(breakpoint_0)));
        var tmp0_elvis_lhs_8 = view.ebb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view : tmp0_elvis_lhs_8;
        view.gbb(p_8, view_8);
        if (this.wj0_1) {
          var tmp_7 = get_expanding(view_8);
          // Inline function 'com.crowpay.views.components.requiredField' call
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_9 = new (RowOrCol())(view_8.pc());
          var tmp0_elvis_lhs_9 = view_8.ebb_1;
          var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
          view_8.gbb(p_9, view_9);
          view_9.zbm(true);
          view_9.bb9(get_AppDimensions().pg2_1);
          // Inline function 'com.lightningkite.kiteui.views.direct.row' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_10 = new (RowOrCol())(view_9.pc());
          var tmp0_elvis_lhs_10 = view_9.ebb_1;
          var p_10 = tmp0_elvis_lhs_10 == null ? view_9 : tmp0_elvis_lhs_10;
          view_9.gbb(p_10, view_10);
          view_10.zbm(false);
          view_10.bb9(get_AppDimensions().rg2_1);
          view_10.lbb(get_centered(view_10), bodyBold(view_10, 'Email'));
          view_10.lbb(colored(view_10, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_10, '*'));
          view_9.hbb(p_10, view_10);
          // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
          var tmp_8 = view_9.jbb(FieldSemantic_getInstance());
          // Inline function 'com.lightningkite.serialization.lensPath' call
          var this_0 = this.vj0_1;
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_9 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
          var tmp$ret$46 = isInterface(tmp_9, KSerializer()) ? tmp_9 : THROW_CCE();
          var it = new (DataClassPathSelf())(tmp$ret$46);
          var tmp$ret$48 = get_email(it);
          var tmp$ret$49 = lensPath(this_0, tmp$ret$48);
          var value_3 = assertValidEmail(tmp$ret$49);
          // Inline function 'com.lightningkite.kiteui.views.direct.textInput' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_11 = new (TextInput())(view_9.pc());
          var tmp0_elvis_lhs_11 = view_9.ebb_1;
          var p_11 = tmp0_elvis_lhs_11 == null ? view_9 : tmp0_elvis_lhs_11;
          view_9.gbb(p_11, view_11);
          // Inline function 'com.lightningkite.kiteui.views.direct.TextInput.hint' call
          // Inline function 'com.lightningkite.kiteui.views.placeholder' call
          view_11.vb5_1.bb4_1.kb7_1.placeholder = 'Email';
          view_11.zah(view_11.icn_1, value_3);
          view_9.hbb(p_11, view_11);
          view_9.lbb(tmp_8, view_11);
          view_8.hbb(p_9, view_9);
          view_8.lbb(tmp_7, view_9);
        }
        var tmp_10 = get_expanding(view_8);
        // Inline function 'com.crowpay.views.components.requiredField' call
        var label_1 = 'Phone Number';
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_12 = new (RowOrCol())(view_8.pc());
        var tmp0_elvis_lhs_12 = view_8.ebb_1;
        var p_12 = tmp0_elvis_lhs_12 == null ? view_8 : tmp0_elvis_lhs_12;
        view_8.gbb(p_12, view_12);
        view_12.zbm(true);
        view_12.bb9(get_AppDimensions().pg2_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_13 = new (RowOrCol())(view_12.pc());
        var tmp0_elvis_lhs_13 = view_12.ebb_1;
        var p_13 = tmp0_elvis_lhs_13 == null ? view_12 : tmp0_elvis_lhs_13;
        view_12.gbb(p_13, view_13);
        view_13.zbm(false);
        view_13.bb9(get_AppDimensions().rg2_1);
        view_13.lbb(get_centered(view_13), bodyBold(view_13, label_1));
        view_13.lbb(colored(view_13, AppColors_getInstance().jfz_1.zg9_1), bodyBold(view_13, '*'));
        view_12.hbb(p_13, view_13);
        // Inline function 'com.lightningkite.kiteui.views.fieldTheme' call
        var tmp_11 = view_12.jbb(FieldSemantic_getInstance());
        // Inline function 'com.crowpay.path' call
        Companion_getInstance();
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_12 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
        var tmp$ret$66 = isInterface(tmp_12, KSerializer()) ? tmp_12 : THROW_CCE();
        var tmp$ret$68 = new (DataClassPathSelf())(tmp$ret$66);
        var value_4 = assertValidPhoneNumber(lensPath(this.vj0_1, get_phoneNumber(tmp$ret$68)));
        // Inline function 'com.lightningkite.kiteui.views.direct.phoneNumberInput' call
        // Inline function 'kotlin.apply' call
        var this_1 = new (PhoneNumberInput())(view_12);
        this_1.vcl('Phone Number');
        view_12.zah(this_1.c2a(), value_4);
        view_12.lbb(tmp_11, this_1);
        view_8.hbb(p_12, view_12);
        view_8.lbb(tmp_10, view_12);
        view.hbb(p_8, view_8);
        var tmp_13 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.daj(this.yj0_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_14 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_14 = view.ebb_1;
        var p_14 = tmp0_elvis_lhs_14 == null ? view : tmp0_elvis_lhs_14;
        view.gbb(p_14, view_14);
        view_14.zbm(true);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_15 = new (Space())(view_14.pc());
        var tmp0_elvis_lhs_15 = view_14.ebb_1;
        var p_15 = tmp0_elvis_lhs_15 == null ? view_14 : tmp0_elvis_lhs_15;
        view_14.gbb(p_15, view_15);
        view_14.hbb(p_15, view_15);
        // Inline function 'com.crowpay.views.theming.subTitle' call
        var content_0 = 'Billing Address';
        // Inline function 'com.lightningkite.kiteui.views.direct.text' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_16 = new (TextView())(view_14.pc());
        var tmp0_elvis_lhs_16 = view_14.ebb_1;
        var p_16 = tmp0_elvis_lhs_16 == null ? view_14 : tmp0_elvis_lhs_16;
        view_14.gbb(p_16, view_16);
        view_16.lba(view_16.qb6_1.abf(SubtitleSemantic_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
        var tmp_14 = view_16.vb5_1;
        var tmp_15;
        // Inline function 'kotlin.text.isEmpty' call
        if (charSequenceLength(content_0) === 0) {
          tmp_15 = '\xA0';
        } else {
          tmp_15 = content_0;
        }
        tmp_14.hbu(tmp_15);
        view_14.hbb(p_16, view_16);
        // Inline function 'com.lightningkite.serialization.lensPath' call
        var this_2 = this.vj0_1;
        // Inline function 'com.lightningkite.lightningdb.path' call
        // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
        var tmp_16 = serializerOrContextual(createKType(getKClass(User()), arrayOf([]), false));
        var tmp$ret$90 = isInterface(tmp_16, KSerializer()) ? tmp_16 : THROW_CCE();
        var it_0 = new (DataClassPathSelf())(tmp$ret$90);
        var tmp$ret$92 = get_address(it_0);
        var tmp_17 = lensPath(this_2, tmp$ret$92);
        addressForm(view_14, tmp_17, VOID, VOID, ($this$addressForm) => !$this$addressForm.daj(this.yj0_1));
        view.hbb(p_14, view_14);
        view.lbb(tmp_13, view_14);
        _this__u8e3s4.hbb(p, view);
        return view;
      }
    }
    protoOf($).wcv = get_title;
    initMetadataForClass($, 'UserForm', VOID, VOID, [Page()]);
    UserFormClass = $;
  }
  return UserFormClass;
}
//region block: exports
export {
  UserForm as UserForm7kih3xavfx72,
};
//endregion

//# sourceMappingURL=UserForm.mjs.map
